export default __webpack_public_path__ + "dist/media/White-plus.ffc687f3.svg";